export const SECURITY_ERROR = 'SecurityError';

export enum ApiErrorCodeTypes {
  PASSWORD_TOO_WEAK = 'PASSWORD_TOO_WEAK',
  BAD_CREDENTIALS = 'BAD_CREDENTIALS',
  BAD_PASSWORD = 'BAD_PASSWORD',
  BAD_REQUEST = 'BAD_REQUEST',
  DEFAULT_ERROR_MESSAGE = 'DEFAULT_ERROR_MESSAGE',
  IPI_NOT_FOUND = 'IPI_NOT_FOUND',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  CANNOT_CHANGE_TO_SAME_EMAIL = 'CANNOT_CHANGE_TO_SAME_EMAIL',
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  CONFLICT = 'CONFLICT',
  FORBIDDEN = 'FORBIDDEN',
  INVITE_IS_REVOKED = 'INVITE_IS_REVOKED',
  INVITE_CONSUMED = 'INVITE_CONSUMED',
  ASSOCIATED_WITH_ANOTHER_USER = 'ASSOCIATED_WITH_ANOTHER_USER',
  CHANGE_PASSWORD_REQUIRED = 'CHANGE_PASSWORD_REQUIRED',
  INVALID_CODE = 'INVALID_CODE',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_PROJECT_ID_PROVIDED = 'INVALID_PROJECT_ID_PROVIDED',
  EXPIRED_CODE = 'EXPIRED_CODE',
  MAX_COLLABORATOR_COUNT_EXCEEDED = 'MAX_COLLABORATOR_COUNT_EXCEEDED',
  LIMIT_REACHED = 'LIMIT_REACHED',
  PLAYLIST_AUDIO_LIMIT_REACHED = 'PLAYLIST_AUDIO_LIMIT_REACHED',
  MAX_RELEASE_VERSION_COUNT_IN_TUNECORE_RELEASE_EXCEEDED = 'MAX_RELEASE_VERSION_COUNT_IN_TUNECORE_RELEASE_EXCEEDED',
  INSUFFICIENT_STORAGE = 'INSUFFICIENT_STORAGE',

  // for Auddly migration
  COGNITO_USER_NOT_FOUND = 'COGNITO_USER_NOT_FOUND',
  USER_MUST_COMPLETE_MIGRATION = 'USER_MUST_COMPLETE_MIGRATION',
  INVALID_ISNI = 'INVALID_ISNI',
  LYRIC_VERSION_ALREADY_SET = 'LYRIC_VERSION_ALREADY_SET',
  CONFIGURATION_VERSION_NOT_SUPPORTED = 'CONFIGURATION_VERSION_NOT_SUPPORTED',
}

export enum ApiErrorCodeMessages {
  PASSWORD_TOO_WEAK = 'Your Password is too weak',
  BAD_CREDENTIALS = 'Invalid credentials',
  BAD_PASSWORD = 'Invalid password',
  BAD_REQUEST = 'An unexpected error has occurred',
  DEFAULT_ERROR_MESSAGE = 'An unexpected error has occurred. Please try again later',
  IPI_NOT_FOUND = "IPI doesn't exist",
  LIMIT_EXCEEDED = 'Too many attempts. Please wait a while and try again.',
  CANNOT_CHANGE_TO_SAME_EMAIL = 'Cannot change to the same email',
  ENTITY_NOT_FOUND = 'Cannot find requested entity',
  USER_NOT_CONFIRMED = 'You must confirm your email address before you can login, check your inbox',
  CONFLICT = 'Conflicting request',
  FORBIDDEN = 'Request not allowed',
  INVITE_IS_REVOKED = 'This invite is no longer active.',
  INVITE_CONSUMED = 'This invite link has already been used.',
  ASSOCIATED_WITH_ANOTHER_USER = 'This invite is already associated with another user.',
  CHANGE_PASSWORD_REQUIRED = 'Current password is too weak. Consider updating your password first.',
  INVALID_CODE = 'Code invalid',
  INVALID_EMAIL = 'Email is invalid',
  INVALID_PROJECT_ID_PROVIDED = 'Invalid Project ID',
  EXPIRED_CODE = 'Code is expired',
  COGNITO_USER_NOT_FOUND = 'User not found',
  USER_MUST_COMPLETE_MIGRATION = 'You have to complete account migration',
  INVALID_ISNI = 'ISNI number is invalid',
  LYRIC_VERSION_ALREADY_SET = 'A selection was already made by another collaborator',
  CONFIGURATION_VERSION_NOT_SUPPORTED = 'You have to update Application to use Lyrics.',
  CREDIT_INVALID_ISNI_MESSAGE = 'The ISNI you have entered is invalid. Please add a valid ISNI',
  MAX_COLLABORATOR_COUNT_EXCEEDED = 'You’ve reached the maximum number {NUM} of collaborators',
  MAX_RELEASE_VERSION_COUNT_IN_TUNECORE_RELEASE_EXCEEDED = "Can't add more audios",
}

export enum ThemeMode {
  DARK = 'dark',
  LIGHT = 'light',
  SYSTEM = 'system',
}

export enum IdType {
  ISNI = 'isni',
  IPI = 'ipi',
  IPN = 'ipn',
}

export enum SocialType {
  APPLE = 'appleMusic',
  SPOTIFY = 'spotify',
  YOUTUBE = 'youtube',
}

export enum ProfileImageSize {
  AVATAR_TINY = 'avatar-tiny',
  AVATAR_SMALL = 'avatar-small',
}

export enum ContentContainerType {
  LIST = 'LIST',
  NARROW_LIST = 'NARROW_LIST',
  FORM = 'FORM',
  APP = 'APP',
}

export enum DeeplinkActions {
  ADD_SONG = 'ADD_SONG',
}

export enum LoadingState {
  PRISTINE = 'PRISTINE',
  FETCHING = 'FETCHING',
  FETCHED = 'FETCHED',
  ERROR = 'ERROR',
}

export enum MobileOperatingSystems {
  IOS = 'iOS',
  ANDROID = 'Android',
  WINDOWS = 'Windows Phone',
}

export enum AuthPersistence {
  NONE = 'NONE',
  APP = 'APP',
  REMEMBER = 'REMEMBER',
}

export enum SignUpFormStep {
  BASIC = 'basic',
  DETAILS = 'details',
  USER_PERSONA = 'userPersona',
}

export enum IdVerificationStatus {
  SUCCESS = 'successful',
  FAILURE = 'failed',
  CANCELLED = 'cancelled',
}

export enum AuddlySignUpFormStep {
  PASSWORD_CREATION = 'password_creation',
  LOCATION_DETAILS = 'location_details',
}

export enum EntityType {
  SONG = 'SONG',
  COLLABORATOR = 'COLLABORATOR',
}

export enum ImageStatusType {
  READY_FOR_UPLOAD = 'READY_FOR_UPLOAD',
  PROCESSING = 'PROCESSING',
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}
